import { Link } from "react-router-dom";
import "./FrequentlyServices.scss";

import certificate from "../../assets/images/sidebar-icons/certificate.svg";
import category from "../../assets/images/sidebar-icons/category.svg";
import carpet from "../../assets/images/sidebar-icons/carpet.svg";


const Services = [
  {
    id: 0,
    name: "شناسنامه ها",
    route: "/Certificate/Show-Certificate",
    image: certificate,
  },
  {
    id: 1,
    name: "فرش ها",
    route: "/Carpet/Managment-Carpet",
    image: carpet,
  },
  {
    id: 2,
    name: "دسته بندی",
    route: "/Carpet/Create-Category",
    image: category,
  }
];

const FrequentlyServices = () => {
  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <div className="services-container">
          {Services.map((service) => {
            return (
              <Link to={service.route} key={service.id}>
                <div className="service-container">
                  <img src={service.image} alt="service-logo" />
                  {/* <span>
                                        تست
                                    </span> */}
                  <p>{service.name}</p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FrequentlyServices;
